import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UploadShowChoiceComponent } from "../upload-show-choice/upload-show-choice.component";
import { PrimaryButtonComponent } from "../../../../../shared/components/primary-button/primary-button.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { NavigationShareService } from '../../../../../core/services/navigation-share.service';
import { HttpClientTestingModule } from '@angular/common/http/testing';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-onboarding-step-four',
  standalone: true,
  imports: [UploadShowChoiceComponent, PrimaryButtonComponent, TranslocoPipe, HttpClientTestingModule],
  templateUrl: './onboarding-step-four.component.html',
  styleUrl: './onboarding-step-four.component.css'
})
export class OnboardingStepFourComponent {
  @Input() selectedOption: string = 'upload';
  @Output() selectedOptionChange: EventEmitter<string> = new EventEmitter<string>();

  termsAndConditionsURL = environment.termsAndConditions;

  constructor(private router: Router, private shareService: NavigationShareService) { }

  onSelectedOptionChange() {
    this.selectedOptionChange.emit(this.selectedOption);
  }

  continueButtonClick() {
    this.shareService.setState('onboarding_done', true);
    this.router.navigate(['/dashboard/overview']);
  }
}
